<template>
    <div class="image-carousel slider">
        <div class="container">
            <carousel-3d
                :perspective="10"
                :display="3"
                :space="isPhone ? 120 : 200"
                :height="isPhone ? 432 : 566"
                :width="isPhone ? 276 : 361"
                :border="0"
                :controlsVisible="false"
                ref="carousel"
                @before-slide-change="onBeforeSlideChange">
                <slide :index="0">
                    <img
                        data-src="https://images.iphonephotographyschool.com/34617/dub1.jpg?width=1128"
                        src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 432 276'></svg>"
                        :height="isPhone ? 432 : 564"
                        :width="isPhone ? 276 : 360"
                        class="lazy"
                        alt="dubai photo promotion" />
                </slide>
                <slide :index="1">
                    <img
                        data-src="https://images.iphonephotographyschool.com/34618/dub2.jpg?width=1128"
                        src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 432 276'></svg>"
                        :height="isPhone ? 432 : 564"
                        :width="isPhone ? 276 : 360"
                        class="lazy"
                        alt="dubai photo promotion" />
                </slide>
                <slide :index="2">
                    <img
                        data-src="https://images.iphonephotographyschool.com/34619/dub3.jpg?width=1128"
                        src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 432 276'></svg>"
                        :height="isPhone ? 432 : 564"
                        :width="isPhone ? 276 : 360"
                        class="lazy"
                        alt="dubai photo promotion" />
                </slide>
            </carousel-3d>
            <div class="indicator">
                <span v-for="i in 3" :key="i" :class="{ active: index === i - 1 }" @click="goToSlide(i - 1)"></span>
            </div>
            <div class="container">
                <i class="caption">{{ $t('iga.carouselCaption') }}</i>
            </div>
        </div>
    </div>
</template>

<script>
import { Carousel3d, Slide } from '@nanoandrew4/vue3-carousel-3d';
import { helpers } from '../../helpers';

export default {
    components: {
        Carousel3d,
        Slide,
    },
    data() {
        return {
            index: 0,
        };
    },
    computed: {
        isPhone() {
            return helpers.isPhone();
        },
    },
    methods: {
        onBeforeSlideChange(index) {
            this.index = index;
        },
        goToSlide(index) {
            this.$refs.carousel.goSlide(index);
        },
    },
};
</script>

<style lang="sass">
.new_sp--iga
    .image-carousel
        padding: 80px 0
        overflow: hidden

        .container
            display: flex
            flex-direction: column
            justify-content: center
            align-items: center
            gap: 20px

        .carousel-3d-slider
            perspective: 1000px !important
            transition: all .6s ease-in-out

        &.open
            .carousel-3d-slider
                perspective: 1000px !important

            .carousel-3d-slide
                &.left-1
                    @media screen and (min-width: 568px)
                        img
                            transform: translateX(-30px)

                &.right-1
                    @media screen and (min-width: 568px)
                        img
                            transform: translateX(30px)

        .carousel-3d-container
            margin: 0
            overflow: visible
            cursor: grab

            &:focus
                cursor: grabbing

            .carousel-3d-slide
                background: none
                overflow: visible
                will-change: transform

                img
                    border-radius: 24px
                    width: 360px
                    height: auto
                    box-shadow: rgba(0, 0, 0, 0.25) 16px 16px 84px 0px
                    transform: none !important
                    transition: transform 500ms ease
                    will-change: transform


        .carousel-3d-controls
            @media screen and (min-width: 768px)
                display: none

            @media screen and (min-width: 1366px)
                display: block

            .prev,
            .next
                display: flex
                align-items: center
                justify-content: center
                height: 62px
                width: 62px
                font-size: 28px
                border-radius: 50%
                background: linear-gradient(139.81deg, rgba(235, 237, 254, 0.6) 13.11%, rgba(235, 237, 254, 0.1) 84.95%)
                box-shadow: 4px 4px 21px -1px rgba(0, 0, 0, 0.25)
                backdrop-filter: blur(20px)

                &:hover
                    opacity: 1

            .prev
                left: -30px

            .next
                right: -30px

        .caption
            position: relative
            min-height: 80px
            font-weight: 400
            color: #57575c !important
            text-align: center

            @media screen and (min-width: 568px)
                min-height: 52px

        .indicator
            display: flex
            justify-content: center
            padding: 10px
            gap: 10px
            width: min-content
            height: min-content

            span
                height: 10px
                width: 10px
                border-radius: 50%
                background: rgba(122, 122, 122, 0.4)
                cursor: pointer

                &.active
                    background: rgb(122, 122, 122)
</style>
